

/**
 * @typedef {Object} RouterRequirementStates
 * @property {String} activityFeed
 * @property {String} details
 */

/** @type {RouterRequirementStates} */
export const assetFileRequirementStates = {
  activityFeed: 'app.assets.file-requirement-activity-feed',
  details: 'app.assets.file-upload',
};

/** @type {RouterRequirementStates} */
export const assetFormRequirementStates = {
  activityFeed: 'app.assets.form-requirement-activity-feed',
  details: 'app.assets.form',
};

/** @type {RouterRequirementStates} */
export const projectFileRequirementStates = {
  activityFeed: 'app.projects.file-requirement-activity-feed',
  details: 'app.projects.file-upload',
};

/** @type {RouterRequirementStates} */
export const projectFormRequirementStates = {
  activityFeed: 'app.projects.form-requirement-activity-feed',
  details: 'app.projects.form',
};



// WEBPACK FOOTER //
// ./src/js/requirements/router-config.js